export default [
  {
    path: '/plans/containerPest/list',
    name: 'plans.containerPest.list',
    component: () => import('@/views/modules/plans/containerPest-plan/ListPlans'),
    meta: {
      module: 'plans.containerPest',
      pageTitle: 'Plan List',
      breadcrumb: [
        { text: 'List Plans', active: true, }
      ],
    }
  },


  {
    path: '/plans/containerPest/create',
    name: 'plans.containerPest.create',
    component: () => import('@/views/modules/plans/containerPest-plan/CreatePlan'),
    meta: {
      module: 'plans.containerPest',
      pageTitle: 'Plan Create',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.containerPest.list'} },
        { text: 'Create Plan' , active: true}
      ],
    }
  },


  {
    path: '/plans/containerPest/:id/edit',
    name: 'plans.containerPest.edit',
    component: () => import('@/views/modules/plans/containerPest-plan/EditPlan'),
    meta: {
      module: 'plans.containerPest',
      pageTitle: 'Plan Edit',
      breadcrumb: [
        { text: 'List Plans', to: {name: 'plans.containerPest.list'} },
        { text: 'Edit Plan' , active: true}
      ],
    }
  },
]
